import { createI18n } from "vue-i18n";
import en from "../locales/en.json";
import da from "../locales/da.json";
import de from "../locales/de.json";
import es from "../locales/es.json";
import fi from "../locales/fi.json";
import frCA from "../locales/fr-CA.json";
import frFR from "../locales/fr-FR.json";
import it from "../locales/it.json";
import nb from "../locales/nb.json";
import nl from "../locales/nl.json";
import ptBR from "../locales/pt-BR.json";
import ptPT from "../locales/pt-PT.json";
import sv from "../locales/sv.json";

export const i18n = createI18n({
  locale: "en",
  globalInjection: true,
  legacy: false,
  runtimeOnly: true,
  fallbackLocale: "en",
  messages: {
    en,
    da,
    de,
    es,
    fi,
    fr_CA: frCA,
    fr_FR: frFR,
    it,
    nb,
    nl,
    pt_BR: ptBR,
    pt_PT: ptPT,
    sv,
  },
});

export function updateI18nLocale(locale: string) {
  // Normalize: replace hyphens with underscores (en-US -> en_US, fr-CA -> fr_CA)
  const normalized = locale.replace(/-/g, "_");
  const availableLocales: string[] = i18n.global.availableLocales;

  let finalLocale = "en";

  // If we have this exact locale, use it (e.g., fr_CA, pt_BR)
  if (availableLocales.includes(normalized)) {
    finalLocale = normalized;
  }
  // Otherwise, try the base language (e.g., en-US -> en, de-DE -> de)
  else {
    const baseLanguage = normalized.split("_")[0];
    if (availableLocales.includes(baseLanguage)) {
      finalLocale = baseLanguage;
    }
  }

  i18n.global.locale.value = finalLocale as any;
}